import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedAnswersState {
  selectedAnswerIds: string[];
}

const initialState: SelectedAnswersState = {
  selectedAnswerIds: [],
};

const selectedAnswersSlice = createSlice({
  name: 'selectedAnswers',
  initialState,
  reducers: {
    toggleAnswerSelection: (state, action: PayloadAction<string>) => {
      const index = state.selectedAnswerIds.indexOf(action.payload);
      if (index === -1) {
        state.selectedAnswerIds.push(action.payload);
      } else {
        state.selectedAnswerIds.splice(index, 1);
      }
    },
  },
});

export const { toggleAnswerSelection } = selectedAnswersSlice.actions;
export default selectedAnswersSlice.reducer;